/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Removed_SuccessfullyInputs */



/**
* | output |
* | --- |
* | "Share was successfully removed" |
*
* @param {Team_Share_Removed_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_removed_successfully = /** @type {((inputs?: Team_Share_Removed_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Removed_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le partage a été supprimé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Freigabe wurde erfolgreich entfernt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La condivisione è stata rimossa con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Доля была успешно удалена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El recurso compartido se eliminó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分享已成功移除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("共有が正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेयर सफलतापूर्वक हटा दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A partilha foi removida com sucesso.")
	return /** @type {LocalizedString} */ ("Share was successfully removed")
});